// extracted by mini-css-extract-plugin
export default {"user-desc-wrapper":"user-desc-wrapper_T2vsQ","button-group":"button-group_XWcKW"};